import React, { useMemo } from 'react';

import { ProgressWidget } from 'components/Statistic/ProgressWidget';
import { Plan } from 'types';

type PricingStatusWidgetProps = {
  plan?: Plan,
  loading: boolean,
};

export const PricingStatusWidget = ({ plan, loading }: PricingStatusWidgetProps) => {

  const items = useMemo(() => {
    const planStats = plan?.PlanStat?.stats;

    return !plan
      ? []
      : [
        { title: 'Employee Priced', percent: Math.round((planStats?.mappedEmployees * 100) / planStats?.totalEmployees), strokeColor: '#55C2EF'},
        { title: 'Jobs Priced', percent: Math.round((planStats?.mappedJobs * 100) / planStats?.totalJobs), strokeColor: '#51D9C2'},
      ];
  }, [plan]);

  return (
    <ProgressWidget
      label={`Pricing Status - ${plan?.name}`}
      items={items}
      loading={loading}
    />
  );
};
